/* eslint-disable @stylistic/max-len */
import classNames from 'classnames';

import style from './arrow.module.css';

type ArrowDirection = 'down' | 'left' | 'right' | 'up';
type IconColor = 'black' | 'white';

interface ArrowProps {
  className?: string;
  direction?: ArrowDirection;
  disabled?: boolean;
  iconColor?: IconColor;
}

const arrowDirectionMap: Record<ArrowDirection, string> = {
  down: style.arrowDown,
  left: style.arrowLeft,
  right: '',
  up: style.arrowUp,
};

const iconColorMap: Record<IconColor, string> = {
  black: style.arrowIconBlack,
  white: style.arrowIconWhite,
};

const Arrow = ({
  className,
  direction = 'right',
  disabled,
  iconColor = 'white',
}: ArrowProps) => {
  return (
    <svg
      className={classNames(
        arrowDirectionMap[direction],
        className,
      )}
      fill="none"
      height="49"
      viewBox="0 0 49 49"
      width="49"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        className={classNames(
          style.arrowIconCircle,
          { [style.disabledBackground]: disabled },
        )}
        height="49"
        rx="24.5"
        width="49"
      />
      <path
        className={classNames(
          iconColorMap[iconColor],
          { [style.disabledIcon]: disabled },
        )}
        d="M33.7071 24.7071C34.0976 24.3166 34.0976 23.6834 33.7071 23.2929L27.3431 16.9289C26.9526 16.5384 26.3195 16.5384 25.9289 16.9289C25.5384 17.3195 25.5384 17.9526 25.9289 18.3431L31.5858 24L25.9289 29.6569C25.5384 30.0474 25.5384 30.6805 25.9289 31.0711C26.3195 31.4616 26.9526 31.4616 27.3431 31.0711L33.7071 24.7071ZM15 25H33V23H15V25Z"
      />
    </svg>
  );
};

export default Arrow;
